import type { VFC } from 'react';

import { Badge, BadgeColors } from '../../../generic/Badge';
import type { EpssResponse } from '../../../../../shared/issuesV2';
import { getHumanReadableEPSS } from '../../../../utils';
import Tooltip, { TooltipContent } from '../../../generic/Tooltip';

type Props = {
  tooltipId: string;
  epss: EpssResponse;
  showTooltip?: boolean;
};

/**
 * Display a simple badge with a vuln's EPSS score and percentile.
 */
const EpssBadge: VFC<Props> = ({ tooltipId, epss, showTooltip = true }) => {
  const { label, explanation } = getHumanReadableEPSS(epss);

  return (
    <Tooltip id={tooltipId} tooltip={<TooltipContent maxWidth="280px">{explanation}</TooltipContent>} showTooltip={showTooltip}>
      <div>
        <Badge color={BadgeColors.White}>{label}</Badge>
      </div>
    </Tooltip>
  );
};

export default EpssBadge;
